module.exports = __webpack_public_path__ + "static/media/loading.365f6430.gif";